module.exports = __webpack_public_path__ + "static/media/big-shield-icon.3e7ba598.png";